const ArticleToc = () => {
  const articleContainer = document.querySelector('.article__container');
  if (!articleContainer) return;

  const articleTocWrapper = articleContainer.querySelector('.article__toc-wrapper');
  if (!articleTocWrapper) return;

  const desktopOpener = articleTocWrapper.querySelector('.article__toc-opener');
  const mobileOpener = articleTocWrapper.querySelector('.article__mobile-toc-opener');
  const tocBlock = articleTocWrapper.querySelector('.article__toc');
  const links = Array.from(tocBlock.querySelectorAll('.article__toc-item-link'));
 
  const articleContent = articleContainer.querySelector('.article__content');
  if (!articleContent) return;

  const toggleOpen = () => {
    articleTocWrapper.classList.toggle('opened');
  };

  desktopOpener?.addEventListener('click', toggleOpen);
 
  if (window.innerWidth < 1024) {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const rect = articleContent.getBoundingClientRect();
          if (rect.top < 0) {
            articleTocWrapper.classList.add('sticky');
          } else {
            articleTocWrapper.classList.remove('sticky');
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); 

    mobileOpener?.addEventListener('click', toggleOpen);

    links.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').slice(1);
        const targetEl = document.getElementById(targetId);

        articleTocWrapper.classList.remove('opened');

        const onTransitionEnd = () => {
          articleTocWrapper.removeEventListener('transitionend', onTransitionEnd);
          if (targetEl) {
            const stickyHeight = articleTocWrapper.offsetHeight; 
            const targetPosition = targetEl.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
              top: targetPosition - stickyHeight,
              behavior: "smooth"
            });
          }
        };

        articleTocWrapper.addEventListener('transitionend', onTransitionEnd);
      });
    });

    document.addEventListener('click', (e) => {
      if (!articleTocWrapper.contains(e.target)) {
        articleTocWrapper.classList.remove('opened');
      }
    });
  }
};

export default ArticleToc;